import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectSelectedUsersInfo = createSelector(
  [(store: RootState) => store.massiveDocumentCreate.selectedUsersInfo],
  (data) => data
);
